export const BILLING_ROUTE = '/billing';
export const METAL_PRICING_ROUTE = '/metal-pricing';
export const BATCH_SHIPMENTS_ROUTE = '/batch-shipments';
